import React from "react";

import AccountForm from "./AccountForm";
import BusinessForm from "./BusinessForm";
import EmailForm from "./EmailForm";

import { GoogleLogo } from "../helpers/Logos";

import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import BusinessIcon from '@mui/icons-material/Business';
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PersonIcon from '@mui/icons-material/Person';
import Stepper from '@mui/material/Stepper';
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from '@mui/material/Typography';

const steps = [
    { label: 'Account Details' },
    { label: 'Business Details' },
    { label: 'Approval of Account' }
];

export const renderAlreadyAccount = () => {
    return (
        <Typography variant="body1" sx={{ mt: 13, color: 'white' }}>
            Already have an account?{' '}
            <Link
                href="/login"
                underline="always"
                sx={{
                    color: 'white',
                    textDecoration: 'underline',
                    textDecorationColor: 'white',
                    '&:hover': {
                        textDecorationColor: 'white',
                    },
                }}
            >
                Login
            </Link>
        </Typography>
    )
}

export const renderSteps = (activeStep) => {
    return (
        <Box sx={{ maxWidth: 400 }}>
            <Stepper
                activeStep={activeStep}
                orientation="vertical"
                sx={{
                    // all labels, whether default, active or completed, will be white
                    '& .MuiStepLabel-label': {
                        color: 'white',
                    },
                    '& .MuiStepLabel-label.Mui-active': {
                        color: 'white',
                    },
                    '& .MuiStepLabel-label.Mui-completed': {
                        color: 'white',
                    },
                }}
            >
                {steps.map((step) => (
                    <Step key={step.label}>
                        <StepLabel>{step.label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
    )
}

export const renderAuthPage = (handleNext, onSignUpGoogle) => {
    return (
        <React.Fragment>
            <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                <PersonIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Register Account
            </Typography>
            <Box sx={{ mt: 1, maxWidth: 500, minWidth: 500 }}>
                <Typography component="h1" variant="h6" sx={{ mt: 3, mb: 3 }}>
                    Continue with your email address to get access!
                </Typography>
                <EmailForm onSubmit={handleNext} />
                <Divider sx={{ mt: 3, mb: 3 }}>or</Divider>
                <Button
                    fullWidth
                    variant="outlined"
                    startIcon={GoogleLogo(20, 20)}
                    onClick={() => { onSignUpGoogle() }}
                >
                    Register with Google
                </Button>
            </Box>
        </React.Fragment>
    )
}

export const renderAccountPage = (handleNext) => {
    return (
        <React.Fragment>
            <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Account Details
            </Typography>
            <Box sx={{ mt: 1, maxWidth: 500, minWidth: 500 }}>
                <AccountForm onSubmit={handleNext} />
            </Box>
        </React.Fragment>
    )
}

export const renderBusinessPage = (onSubmit, flow) => {
    return (
        <React.Fragment>
            <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                <BusinessIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Business Details
            </Typography>
            <Box sx={{ mt: 1, maxWidth: 500, minWidth: 500 }}>
                <BusinessForm onSubmit={onSubmit} flow={flow} />
            </Box>
        </React.Fragment>
    )
}

export const renderSignupPage = (email, passwordFlow, emailSent, onResend) => {
    return (
        <React.Fragment>
            <Typography component="h1" variant="h5" sx={{ mt: 5 }}>
                Approval of Account
            </Typography>
            {passwordFlow ?
                <Typography variant="body" display="block" color="text.secondary" sx={{ mt: 3, mb: 3 }}>
                    Please verify the email address by clicking the link in the email we just sent to {email}. When verified, please get in contact with us to get full access.
                </Typography>
                :
                <Typography variant="body" display="block" color="text.secondary" sx={{ mt: 3, mb: 3 }}>
                    Your account has now been created. Please get in contact with us to get full access.
                </Typography>
            }
            {passwordFlow ?
                <Button variant="contained" disabled={emailSent} onClick={() => { onResend(email) }}>
                    Resend Verification Email
                </Button>
                : null}
        </React.Fragment>
    )
}
